import * as moment from "moment";
import { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import TimePicker from "react-time-picker";
import { toast, ToastContainer } from "react-toastify";
import {
  Categories_list,
  Channel_create,
  Channel_update,
  ChannelType_list,
  epgHandlersList,
  FillerList,
  getAllFillers,
  GetChannelById,
  Languages_list,
  Partner_list,
  Theme_list,
  Timezone_list,
} from "../../api/api";
import "../../assets/css/style.scss";
import CustomDatePickerField from "../../component/Common/DatePickerField";
import FileUploaderContainer from "../../component/Common/File-Uploader-Container/FileUploaderContainer";
import JsonTextArea from "../../component/Common/JsonTextArea";
import MultiSelectField from "../../component/Common/MutiSelectChannel";
import ToggleButtonChannel from "../../component/Common/ToggleButtonChannel";
import CDNPopUp from "../../component/popup/CDNPopUp";
import CustomAttributeModal from "../../component/popup/CustomAttributeModal";
import appStore from "../../Config/Store/appStore";
import {
  defaultFileUploaded,
  defaultFormError,
  defaultFormValue,
} from "../../dummyjson/channelDefaultValues";
import { permissionDetails } from "../../utility/localStoageData";
import "./channelCreation.scss";
import expandIcon from "../../assets/images/open_in_full.svg";

function ChannelCreation() {
  const { control, register, handleSubmit } = useForm({
    defaultValues: defaultFormValue,
  });
  const textareaRef = useRef(null);

  const state = useSelector((state) => state);
  const Territorys = state?.CountryList?.data?.data || [];
  const Ratings = state?.MaturityList?.data;

  const locationState = useLocation();

  // Form State
  const createInitialForm = () => ({
    ...defaultFormValue,
    channelImages: JSON.parse(JSON.stringify(defaultFileUploaded)),
  });
  const [formData, setFormData] = useState(createInitialForm);
  // Error State
  const [errors, setErrors] = useState({ ...defaultFormError });
  let defaultattributes = { csai_ad_tag: "", vast_csai_tag: "" };
  // Special Fiels Stat Handling
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [channelId, setChannelId] = useState("");
  const [playoutBaseUrl, setplayoutBaseUrl] = useState("");
  const [apiUrl, setapiUrl] = useState("");

  const [customAttributes, setCustomAttributes] = useState(
    JSON.stringify(defaultattributes, null, 2)
  );

  // Create or Update Identification Flag
  const [isEdit, setIsEdit] = useState(false);
  const [assemblyEdit, setassemblyEdit] = useState(false);
  const [externalUrlBool, setExternalUrlBool] = useState(false);
  const [editChannelData, setEditChannelData] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);

  // Field Options State
  const [partnerOption, setPartnerOptions] = useState([]);
  const [territoryOption, setTerritoryOption] = useState([]);
  const [categoryOption, setCategoryOption] = useState([]);
  const [channelTypeList, setChannelTypeList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [themeList, setThemeList] = useState([]);
  const [fillerList, setFillerList] = useState([]);
  const [timezoneList, setTimezoneList] = useState([]);
  const [PartnerfillerList, setPartnerfillerList] = useState([]);
  const [dataCheckvalid, setdataCheckvalid] = useState({ ...defaultFormValue });
  const [storeFrontAccess, setStoreFrontAccess] = useState("");
  const [inputCon, setInputCon] = useState(true);
  const [epgHandlerData, setEpgHandlerData] = useState("");
  const [permission, setpermission] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [identifier, setIdentifier] = useState("");
  const [ratingList, setRatingList] = useState([]);

  const [ratingsDescriptor, setRatingsDescriptor] = useState("");

  const navigate = useNavigate();

  const backToChannel = () => {
    if (!externalUrlBool) {
      resetForm();
    }
    navigate("/channel", {
      state: {
        currentPage: currentPage,
      },
    });
  };

  const backToChannels = () => {
    if (JSON.stringify(formData) !== JSON.stringify(dataCheckvalid)) {
      navigate("/channel", { state: { currentPage } });
    } else {
      // Objects are the same
      navigate(-1);
    }
  };

  const [errorbox, setErrorbox] = useState(false);

  const errorboxclose = () => {
    setErrorbox(false);
  };

  const accessStore = async () => {
    const tenantLocalData = localStorage.getItem("tenantInfo");
    const tenantLocalDataParse = await JSON.parse(tenantLocalData);
    setStoreFrontAccess(tenantLocalDataParse?.identifier);
    setIdentifier(tenantLocalDataParse?.code);
  };
  const getEpgHandlersList = async () => {
    const response = await epgHandlersList();
    setEpgHandlerData(response?.data);
  };

  const getPermission = () => {
    let findEdit = permissionDetails();
    if (findEdit.includes("CHANNEL_SETUP_EDIT")) setpermission("edit");
    else if (findEdit.includes("CHANNEL_SETUP_READ")) setpermission("read");
    else setpermission(null);
  };

  useEffect(() => {
    getPermission();
    setRatingList(Ratings);
    accessStore();
    getPartnerList();
    getChannelTypeList();
    getLanguageList();
    getTimeZoneList();
    getChannelCategoryList();
    getChannelThemeList();
    getCountriesList();
    getEpgHandlersList();
    getPermission();
    // initializeDropdownOptions();
    if (locationState?.state?.id) {
      setIsEdit(true);
      setCurrentPage(locationState?.state?.currentPage);
      getChannelById(locationState.state.id);
    }
    // let rate = ratings[0]?.id
    // setRating(rate);
    getPartnerFiller();
    if (!locationState?.state?.id) {
      // Ensure fresh images when creating a new channel
      setFormData((prev) => ({
        ...createInitialForm(),
        // keep any defaults that might be computed above
        goLiveDate: prev.goLiveDate || new Date(),
        channelSetupDate: prev.channelSetupDate || new Date(),
      }));
    }
    // setRating();
  }, []);

  useEffect(() => {
    if (Ratings?.length > 0 && formData.ratingId) {
      const selectedItem = Ratings.find(
        (item) => item.id === Number(formData.ratingId)
      );
      if (selectedItem) {
        setRatingsDescriptor(selectedItem.description);
      }
    }
  }, [Ratings, formData.ratingId]);

  useEffect(() => {
    if (Territorys.length > 0) {
      let countries = Territorys.map((item) => ({
        territoryId: item.iso,
        territoryName: item.niceName,
      }));

      countries.sort((a, b) => a.territoryName.localeCompare(b.territoryName));

      setTerritoryOption(countries); // ✅ Redux state update ke baad set hoga
    }
  }, [Territorys]);

  const getChannelById = async (id) => {
    const channelData = await GetChannelById(id);
    if (channelData) {
      if (channelData?.channelAssembly === "EXTERNAL") {
        setInputCon(false);
      }
      setEditChannelData(channelData);
      setEditFormData(channelData);
    }
  };

  // Set Form Data
  const setEditFormData = async (data) => {
    let editFormData = { ...formData };

    editFormData.id = data.id;
    editFormData.categories = data.categories;
    editFormData.channelId = data.channelId;
    editFormData.playoutBaseUrl = data.playoutBaseUrl;
    editFormData.customAttributes = data.customAttributes;
    editFormData.isStartOverEnabled = data.isStartOverEnabled;
    editFormData.isWatchListEnabled = data.isWatchListEnabled;
    editFormData.regionalLanguage = data?.regionalLanguage?.id;
    editFormData.territoryDetails = data.territoryDetails;
    editFormData.partners = data.partners;
    editFormData.theme = data.theme;
    editFormData.type = data.type;
    editFormData.playbackUrl = data.playbackUrl;
    editFormData.name = data.name;
    editFormData.fillerSourcePath = data.filler?.id;
    editFormData.channelAssembly = data.channelAssembly;
    editFormData.channelTags = data.channelTags?.split(",");
    editFormData.description = data.description;
    editFormData.epgType = data.epgType;
    editFormData.epgHandler = data?.epgHandler;
    editFormData.goLiveDate = new Date(data.goLiveDate);
    editFormData.channelSetupDate = new Date(data.channelSetupDate);
    editFormData.playoutBaseUrl = data.playoutBaseUrl;
    editFormData.epgTypeApiUrl = data.epgTypeApiUrl;
    editFormData.isKidsSafe = data.isKidsSafe;
    editFormData.ratingId = data.rating?.id || "";
    editFormData.scheduleType = data.scheduleType;
    editFormData.timezones = data.timezones;
    editFormData.forceLoginWatchDuration = convertToHHMMSS(
      data.forceLoginWatchDuration
    );

    editFormData.applyLogo = data.applyLogo;

    editFormData.isForceLogin = data.isForceLogin;
    setassemblyEdit(true);
    setapiUrl(data.epgTypeApiUrl);
    setErrors({ ...defaultFormError });

    handleFieldChangeKeyValue("partners", data.partners);
    parseFileUpload(data.channelLogo);
    setName(data.name);
    setDescription(data.description);
    setplayoutBaseUrl(data.playoutBaseUrl);
    setChannelId(data.channelId);
    setFormData({ ...editFormData });
    setExternalUrlBool(true);
    setCustomAttributes(JSON.stringify(data.customAttributes, null, 2));
    setdataCheckvalid({ ...editFormData });
    setTime(convertToHHMMSS(data.forceLoginWatchDuration));
  };

  const parseFileUpload = async (existingFiles) => {
    let fileUploadedLocal = { ...formData.channelImages };
    existingFiles.forEach((item) => {
      fileUploadedLocal[item.size]["poster"].file = item.posterSourcePath
        ? item.posterSourcePath
        : null;
      fileUploadedLocal[item.size]["thumbnail"].file = item.thumbnailSourcePath
        ? item.thumbnailSourcePath
        : null;
      fileUploadedLocal[item.size]["coverart"].file = item.coverartSourcePath
        ? item.coverartSourcePath
        : null;
    });
    handleFileUploader(fileUploadedLocal);
  };
  function isJson(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  // Get Terretory Option List
  const getCountriesList = () => {
    // const countriesData = await Country_list();
    let countries = Territorys?.map((item) => {
      return { territoryId: item.iso, territoryName: item.niceName };
    });

    countries?.sort((a, b) => {
      return a.territoryName.localeCompare(b.territoryName);
    });

    if (countries && countries?.length) {
      setTerritoryOption(countries);
    }
    // setTerritoryOption(Territorys);
  };

  // Get Partner Option List
  const getPartnerList = async () => {
    const partnerData = await Partner_list();
    if (partnerData?.data && partnerData?.status === true) {
      setPartnerOptions(partnerData.data.content);
    }
  };

  // Get Channel Type List
  const getChannelTypeList = async () => {
    const channelTypeList = await ChannelType_list();
    if (channelTypeList && channelTypeList?.length) {
      setChannelTypeList(channelTypeList);
    }
  };

  // Get Language List
  const getLanguageList = async () => {
    const languages = await Languages_list({
      searchText: "",
      ignorePagination:true
    });
    if (languages?.content) {
      setLanguageList(languages.content);
    }
  };
  //get TimeZone List
  const getTimeZoneList = async () => {
    const Timezone = await Timezone_list();
    if (Timezone?.data) {
      setTimezoneList(Timezone?.data);
    }
  };

  // Get Channel Category List
  const getChannelCategoryList = async () => {
    const categoryList = await Categories_list({
      searchText: "",
      sortBy: "name",
      sortOrder: "asc",
      ignorePagination:true
    });
    if (categoryList?.content && categoryList?.content?.length) {
      setCategoryOption(categoryList.content);
    }
  };

  // Get Theme List
  const getChannelThemeList = async () => {
    const themeList = await Theme_list({
      searchText: "",
      sortBy: "name",
      sortOrder: "asc",
      ignorePagination:true
    });
    if (themeList?.content && themeList?.content?.length) {
      setThemeList(themeList.content);
    }
  };

  // Get Filler List
  const getFillerByPartner = async (id) => {
    // const fillerList = await FillerList_By_Partner(id);
    const fillerList = await getAllFillers(id);

    if (fillerList?.data && fillerList?.data?.content?.length) {
      setFillerList(fillerList?.data?.content);
    }
  };
  // Get Filler List
  const getPartnerFiller = async () => {
    const params = {
      // partnerId: AssetPartnerDetail?.id,

      ...(false ? { searchQuery: "" } : null),
      fillerType: "PLATFORM_FILLER",
    };
    const fillerDetail = await FillerList(params);

    setPartnerfillerList(fillerDetail?.data?.content);
  };

  // Handle Changes in Multiple Fields for Validation and State
  const handleMultiFieldChange = (fields) => {
    let formFieldData = { ...formData };
    let errorData = { ...errors };
    fields.forEach((item) => {
      formFieldData[item.name] = item.value;
      if (item.required) {
        errorData[item.name] = validateValue(item.value);
      }
    });
    setFormData(formFieldData);
    setErrors(errorData);
  };

  // Required validation
  const validateValue = (value) => {
    if (value === "" || value === null || value.length === 0) {
      return "Field is Required";
    } else {
      return "";
    }
  };

  // Handle Field Change
  const handleFieldChangeKeyValue = (field, value, required = false) => {
    setFormData({ ...formData, [field]: value });
    if (required) {
      handleFieldValidations({ name: field, value: value });
    }
    if (field === "partners" && value?.length > 0) {
      const listOfId = value.map((item) => item.id);
      getFillerByPartner(listOfId.join());
    } else if (field === "partners" && value?.length === 0) {
      handleFieldValidations({ name: "partners", value: "" });
    }
  };

  // Handle playoutBaseUrl Change
  const handleapiUrlChange = (event) => {
    setapiUrl(event.target.value);
    handleFieldChangeKeyValue(
      event.target.name,
      event.target.value,
      event.target.required
    );
  };

  // Handle Name Change
  const handleNameChange = (event) => {
    if (event.target.value.length <= 100) {
      setName(event.target.value);
      if (!isEdit) {
        generateId(event);
      } else {
        handleMultiFieldChange([
          { name: "name", value: event.target.value, required: true },
        ]);
      }
    }
  };

  // Handle Description Change
  const handleDescriptionChange = (event) => {
    const textarea = textareaRef.current;
    textarea.style.height = textarea.scrollHeight + "px";
    if (event.target.value.length <= 2500) {
      setDescription(event.target.value);
      handleFieldChangeKeyValue(
        event.target.name,
        event.target.value,
        event.target.required
      );
    }
  };

  // Handle Channel ID Change
  const handleChennelIdChange = (event) => {
    if (event.target.value.length <= 8) {
      setChannelId(event.target.value);
      handleFieldChangeKeyValue(
        event.target.name,
        event.target.value,
        event.target.required
      );
    }
  };
  // Function to convert time in HH:MM:SS format to total seconds
  const convertToTotalSeconds = (time) => {
    const [hours, minutes, seconds] = time.split(":").map(Number);

    return hours * 3600 + minutes * 60 + seconds;
  };

  // Handle playoutBaseUrl Change
  const handleplayoutBaseUrlChange = (event) => {
    setplayoutBaseUrl(event.target.value);
    handleFieldChangeKeyValue(
      event.target.name,
      event.target.value,
      event.target.required
    );
  };

  const [time, setTime] = useState();
  // Handle forceLoginWatchDuration Change

  const handleDurationChange = (value) => {
    // If the user deletes the entire time or inputs a value not in "HH:MM:SS" format
    if (value != null) {
      setTime(convertToTotalSeconds(value));
      handleFieldChangeKeyValue("forceLoginWatchDuration", value, true);
    }
     else {
      setTime(convertToTotalSeconds("00:00:00"));
      handleFieldChangeKeyValue("forceLoginWatchDuration", "00:00:00", true);
    }

    
  };

  const convertToHHMMSS = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  // Handle customAttributes  Change
  const handlecustomAttributesChange = (event) => {
    try {
      const jsonString = event.target.value;

      if (typeof jsonString !== "string") {
        throw new Error("Input is not a string");
      }

      JSON.parse(jsonString);
      handleFieldChangeKeyValue(
        event.target.name,
        event.target.value,
        event.target.required
      );
    } catch (error) {
      console.error("Error:", error);

      // setErrors({ ...errors, customAttributes: "Invalid JSON format" });
    }

    setCustomAttributes(event.target.value);
  };

  // Handel to format customAttributes data into pretty-print JSON
  const handleFormatJson = () => {
    try {
      const formattedJson = JSON.stringify(
        JSON.parse(customAttributes),
        null,
        2
      );
      setCustomAttributes(formattedJson);
    } catch (error) {
      // alert("Invalid JSON format");
      toast.error("Invalid JSON format", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        style: { color: "#333333", fontWeight: "bold" },
      });
    }
  };

  // Handle Field Validations
  const handleFieldValidations = (event) => {
    const { name, value } = event;
    setErrors({ ...errors, [name]: validateValue(value) });
  };

  // Reset Form

  const resetForm = () => {
    if (!isEdit) {
      const today = new Date();
      setFormData({
        ...defaultFormValue,
        goLiveDate: today,
        channelSetupDate: today,
        channelImages: JSON.parse(JSON.stringify(defaultFileUploaded)),
      });
      setErrors(defaultFormError);

      setName("");
      setDescription("");
      setChannelId("");
      setplayoutBaseUrl("");
      setCustomAttributes(JSON.stringify(defaultattributes, null, 2));
    } else {
      setEditChannelData(editChannelData);
      setEditFormData(editChannelData);
      const textarea = textareaRef.current;
      textarea.style.height = "auto";
    }
  };

  const generateId = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    const words = value.split(" ");

    // Extracting the first and last word
    const firstWord = words[0].toUpperCase();
    let lastWord = "";
    if (words.length > 1 && words[1].length < 3) {
      // If the second word has less than 3 characters, consider the first word for the last word
      lastWord = firstWord;
    } else {
      lastWord = words[words.length - 1].toUpperCase();
    }

    // Creating the code with the first word and last word's first 3 letters
    let code = firstWord.slice(0, 3) + lastWord.slice(0, 3);

    // If the code is less than 6 letters, add 'X' to make it 6 letters long
    while (code.length < 6) {
      code += "X";
    }

    setChannelId(code);
    handleMultiFieldChange([
      { name: name, value: value, required: true },
      { name: "channelId", value: code, required: true },
    ]);
  };

  const handleFileUploader = (event) => {
    handleFieldChangeKeyValue("channelImages", event, true);
  };

  const validateForm = () => {
    for (const key in errors) {
      if (key !== "channelImages") {
        if (
          (key === "epgHandler" ||
            key === "epgType" ||
            key === "epgTypeApiUrl") &&
          (formData[key] === null ||
            formData[key] === "" ||
            formData[key]?.length === 0)
        ) {
          if (key === "epgHandler" || key === "epgType") {
            if (formData["channelAssembly"] === "EXTERNAL") {
              setErrors((prevErrors) => ({
                ...prevErrors,
                [key]: "Field is Required",
              }));

              return true;
            }
          } else if (
            key === "epgTypeApiUrl" &&
            formData["epgType"] === "APIDriven"
          ) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [key]: "Field is Required",
            }));
            return true;
          } else {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [key]: "",
            }));
          }
        } else if (key === "forceLoginWatchDuration") {
          if (formData.isForceLogin && formData[key] === "00:00:00") {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [key]: "Field is Required",
            }));
            return true;
          } else {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [key]: "",
            }));
          }
        } else if (
          (formData[key] === null ||
            formData[key] === "" ||
            formData[key]?.length === 0) &&
          (key !== "epgHandler" || key !== "epgType" || key !== "epgTypeApiUrl")
        ) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "Field is Required",
          }));
          return true;
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "",
          }));
        }
      } else {
        // Ensure all posters for at least one device are uploaded
        const images = formData[key];
        let validDeviceFound = false;
        Object.keys(images).forEach((deviceKey) => {
          const deviceImages = images[deviceKey];
          if (
            deviceImages.poster.file &&
            deviceImages.thumbnail.file &&
            deviceImages.coverart.file
          ) {
            validDeviceFound = true;
          }
        });
        if (!validDeviceFound) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "Upload all posters for at least one device",
          }));
          return true;
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "",
          }));
        }
      }
    }
    return false;
  };

  const formatGoLiveDate = (data) => {
    if (data) {
      return moment(data).format("YYYY-MM-DD HH:mm:ss");
    } else {
      return "";
    }
  };

  const formatChannelImage = (data) => {
    let files = [];
    Object.keys(data).forEach((key) => {
      Object.keys(data[key]).forEach((innerKey) => {
        if (data[key][innerKey].multiPart) {
          files.push({
            size: key,
            multipartFile: data[key][innerKey].multiPart,
            type: innerKey,
          });
        }
      });
    });
    return files;
  };

  const merge = (data) => {
    const mergedData = data.reduce((acc, obj) => {
      const {
        size,
        posterSourcePath,
        thumbnailSourcePath,
        coverartSourcePath,
      } = obj;

      if (!acc[size]) {
        acc[size] = { size };
      }

      acc[size].posterSourcePath =
        acc[size].posterSourcePath || posterSourcePath;
      acc[size].thumbnailSourcePath =
        acc[size].thumbnailSourcePath || thumbnailSourcePath;
      acc[size].coverartSourcePath =
        acc[size].coverartSourcePath || coverartSourcePath;

      return acc;
    }, {});

    return Object.values(mergedData);
  };

  const getSeperateImages = async (existing, updated) => {
    const deletedImg = [];
    const newImg = [];
    const existingImg = [];
    Object.keys(updated).forEach((parentKey) => {
      Object.keys(updated[parentKey]).forEach((childKey) => {
        let isExist = existing.find((item) => item.size === parentKey);
        if (
          isExist &&
          childKey == "poster" &&
          updated[parentKey][childKey].file === isExist.posterSourcePath
        ) {
          existingImg.push({
            size: isExist.size,
            thumbnailSourcePath: null,
            coverartSourcePath: null,
            posterSourcePath: isExist.posterSourcePath,
          });
        } else if (
          isExist &&
          childKey == "thumbnail" &&
          updated[parentKey][childKey].file === isExist.thumbnailSourcePath
        ) {
          existingImg.push({
            size: isExist.size,
            posterSourcePath: null,
            coverartSourcePath: null,
            thumbnailSourcePath: isExist.thumbnailSourcePath,
          });
        } else if (
          isExist &&
          childKey == "coverart" &&
          updated[parentKey][childKey].file === isExist.coverartSourcePath
        ) {
          existingImg.push({
            size: isExist.size,
            posterSourcePath: null,
            thumbnailSourcePath: null,
            coverartSourcePath: isExist.coverartSourcePath,
          });
        } else if (
          isExist &&
          childKey == "poster" &&
          updated[parentKey][childKey].file === null &&
          isExist.posterSourcePath
        ) {
          deletedImg.push({
            size: isExist.size,
            thumbnailSourcePath: null,
            coverartSourcePath: null,
            posterSourcePath: isExist.posterSourcePath,
          });
        } else if (
          isExist &&
          childKey == "thumbnail" &&
          updated[parentKey][childKey].file === null &&
          isExist.thumbnailSourcePath
        ) {
          deletedImg.push({
            size: isExist.size,
            posterSourcePath: null,
            coverartSourcePath: null,
            thumbnailSourcePath: isExist.thumbnailSourcePath,
          });
        } else if (
          isExist &&
          childKey == "coverart" &&
          updated[parentKey][childKey].file === null &&
          isExist.coverartSourcePath
        ) {
          deletedImg.push({
            size: isExist.size,
            posterSourcePath: null,
            thumbnailSourcePath: null,
            coverartSourcePath: isExist.coverartSourcePath,
          });
        } else {
          if (updated[parentKey][childKey].file) {
            newImg.push({
              size: parentKey,
              multipartFile: updated[parentKey][childKey].multiPart,
              type: childKey,
            });
          }
        }
      });
    });
    return {
      deletedImg: merge(deletedImg),
      newImg: newImg,
      existingImg: merge(existingImg),
    };
  };

  const saveChannel = async () => {
    setdataCheckvalid({ ...formData });
    setDisableBtn(true);

    if (!validateForm()) {
      const payload = {
        channelId: formData.channelId,
        name: formData.name,
        type: formData.type, // Format Type
        description: formData.description,
        goLiveDate: formatGoLiveDate(formData.goLiveDate),
        channelTags: formData.channelTags.join(","),
        playbackUrl: formData.playbackUrl,
        territoryDetails: formData.territoryDetails,
        fillerId: isEdit
          ? formData.channelAssembly === "EXTERNAL"
            ? ""
            : Number(
                formData.fillerSourcePath === ""
                  ? PartnerfillerList[0]?.id
                  : formData.fillerSourcePath
              )
          : String(
              formData.channelAssembly === "EXTERNAL"
                ? ""
                : formData.fillerSourcePath === ""
                ? PartnerfillerList[0]?.id
                : formData.fillerSourcePath
            ),
        regionalLanguages: formData.regionalLanguage,
        theme: returnId(formData.theme),
        categories: returnId(formData.categories),
        partners: returnId(formData.partners),
        channelAssembly: formData.channelAssembly,
        isWatchListEnabled: formData.isWatchListEnabled,
        isStartOverEnabled: !isEdit
          ? String(formData.isStartOverEnabled)
          : formData.isStartOverEnabled,
        playoutBaseUrl: formData.playoutBaseUrl,
        isForceLogin: formData.isForceLogin,
        forceLoginWatchDuration: formData.isForceLogin
          ? convertToTotalSeconds(formData.forceLoginWatchDuration)
          : "0",
        epgType: formData.epgType,
        epgHandler: formData?.epgHandler,
        epgTypeApiUrl: formData.epgTypeApiUrl,
        isKidsSafe: formData.isKidsSafe,
        applyLogo: formData.applyLogo,
        ratingId: Number(formData.ratingId),
        timezones: returnId(formData.timezones),
        scheduleType: formData.scheduleType,
      };

      // Convert File Uploaded to FormData
      // if (isEdit) {
      if (externalUrlBool) {
        // Fetch Edit Image Status
        const fileUploadData = await getSeperateImages(
          editChannelData.channelLogo,
          formData.channelImages
        );
        // Modify Payload
        payload["listExistingImage"] = fileUploadData.existingImg;
        payload["deleteImageList"] = fileUploadData.deletedImg;
        // Convert Payload to FormData
        let jason =
          formData.customAttributes && !isJson(formData.customAttributes)
            ? JSON.stringify(formData.customAttributes)
            : formData.customAttributes;
        const payloadForm = new FormData();
        payloadForm.append("requestBody", JSON.stringify(payload));
        payloadForm.append("customAttributes", jason);
        let thumbIndex = 0;
        fileUploadData.newImg.forEach((value, index) => {
          if (value.type === "thumbnail" && value.multipartFile) {
            payloadForm.append(
              `addChannelImages[${thumbIndex}].size`,
              value.size
            );
            payloadForm.append(
              `addChannelImages[${thumbIndex}].multipartFile`,
              value.multipartFile
            );
            payloadForm.append(
              `addChannelImages[${thumbIndex}].type`,
              "thumbnail"
            );
          }
          if (value.type === "poster" && value.multipartFile) {
            payloadForm.append(
              `addChannelImages[${thumbIndex}].size`,
              value.size
            );
            payloadForm.append(
              `addChannelImages[${thumbIndex}].multipartFile`,
              value.multipartFile
            );
            payloadForm.append(
              `addChannelImages[${thumbIndex}].type`,
              "poster"
            );
          }
          if (value.type === "coverart" && value.multipartFile) {
            payloadForm.append(
              `addChannelImages[${thumbIndex}].size`,
              value.size
            );
            payloadForm.append(
              `addChannelImages[${thumbIndex}].multipartFile`,
              value.multipartFile
            );
            payloadForm.append(
              `addChannelImages[${thumbIndex}].type`,
              "coverart"
            );
          }
          thumbIndex++;
        });

          const response = await Channel_update(payloadForm);
          if (response?.data?.message) {
            toast.success(response?.data?.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000,
            style: { color: "#333333",fontWeight: "bold" }
            });
            setTimeout(() => {
              backToChannel();
              setDisableBtn(false);
            }, 3000);
          } else {
            toast.error(response?.response?.data?.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000,
            style: { color: "#333333", fontWeight: "bold" }
            });
            setDisableBtn(false);
        }
      } else {
        // Convert Payload to FormData
        const payloadForm = new FormData();
        payloadForm.append("requestBody", JSON.stringify(payload));
        payloadForm.append(
          "customAttributes",
          formData.customAttributes === undefined
            ? ""
            : formData.customAttributes
        );
        let thumbIndex = 0;
        let posterIndex = 0;
        let coverIndex = 0;
        formatChannelImage(formData.channelImages).forEach((value, index) => {
          if (value.type === "thumbnail") {
            payloadForm.append(
              `thumbnailImages[${thumbIndex}].size`,
              value.size
            );
            payloadForm.append(
              `thumbnailImages[${thumbIndex}].multipartFile`,
              value.multipartFile
            );
            payloadForm.append(
              `thumbnailImages[${thumbIndex}].type`,
              "thumbnail"
            );
            thumbIndex++;
          }
          if (value.type === "poster") {
            payloadForm.append(`posterImages[${posterIndex}].size`, value.size);
            payloadForm.append(
              `posterImages[${posterIndex}].multipartFile`,
              value.multipartFile
            );
            payloadForm.append(`posterImages[${posterIndex}].type`, "poster");
            posterIndex++;
          }
          if (value.type === "coverart") {
            payloadForm.append(
              `coverartImages[${coverIndex}].size`,
              value.size
            );
            payloadForm.append(
              `coverartImages[${coverIndex}].multipartFile`,
              value.multipartFile
            );
            payloadForm.append(
              `coverartImages[${coverIndex}].type`,
              "coverart"
            );
            coverIndex++;
          }
        });

        const response = await Channel_create(payloadForm);
        if (response?.data?.message) {
          toast.success(response?.data?.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
            style: { color: "#333333" ,fontWeight: "bold"}
          });
          setTimeout(() => {
            backToChannel();
            setDisableBtn(false);
          }, 3000);
        } else {
          toast.error(response?.response?.data?.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
            style: { color: "#333333",fontWeight: "bold" }
          });
          setDisableBtn(false);
        }
      }
    }
  };
  const truncateValue = (text, maxLength = window.innerWidth < 1400 ? 60 : 120) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + "...";
  };

  const returnId = (data) => {
    return data.map((item) => item.id);
  };
  const expandModal = (val) => {
    // If modal is already open, close it; otherwise, open it
    if (appStore.customAttrModal) {
      appStore.setCustomAttrModal(false);
    } else {
      appStore.setCustomAttrModal(true);
    }
  };

  const setfilterRequirement = (value) => {
    if (value === "EXTERNAL") {
      setInputCon(false);
      if (!formData.playbackUrl) {
        setFormData({
          ...formData,
          isStartOverEnabled: false,
          isWatchListEnabled: false,
          channelAssembly: value,
          fillerId: "",
        });
        setIsEdit(true);
      }
    } else {
      setInputCon(true);

      if (!formData.playbackUrl) {
        setFormData({
          ...formData,
          isStartOverEnabled: true,
          isWatchListEnabled: true,
          channelAssembly: value,
          epgHandler: "",
          epgType: "",
          epgTypeApiUrl: "",
        });
      }
      setIsEdit(false);
    }
  };

  const openCDNPopUp = () => {
    setShowPopup(true);
  };
  const closePopup = () => {
    setShowPopup(false);
  };

  return permission !== null ? (
    <div className="content-body pleft">
      <div className="dashboard-content ">
        <div className="top-content">
          <div className="breadcrumbs">
            <ul>
              <li onClick={backToChannels}>Channel Management</li>
              <li className="active">
                {externalUrlBool ? name : "New Channel"}
              </li>
            </ul>
          </div>
        </div>
        <div className="channelCreationForm">
          <form onSubmit={handleSubmit()} className="dark-form">
            <div className="channel-source">
              <h3>Channel Source</h3>
              <div className="form-grid">
                {/* Channel Name */}
                <div className="form-group">
                  <label>
                    Channel Name <span>*</span>
                  </label>
                  <input
                    placeholder="Enter channel name"
                    {...register("name", {
                      required: "Channel Name is required",
                    })}
                    name="name"
                    required
                    type="text"
                    value={name}
                    onChange={(e) => handleNameChange(e)}
                    onBlur={(e) => handleNameChange(e)}
                  />
                  {errors.name && (
                    <span className="error-msg">Channel Name is required</span>
                  )}
                </div>

                <div className="form-group">
                  <label>
                    Channel Partner <span>*</span>
                  </label>
                  <Controller
                    name="channelPartner"
                    control={control}
                    rules={{ required: "Channel Partner is required" }}
                    render={({ field }) => (
                      <>
                        <MultiSelectField
                          className="MultiSelectContainer"
                          options={partnerOption}
                          displayValue="name"
                          selectedValues={formData.partners}
                          placeholder="Select Partner"
                          onSelect={(event) => {
                            handleFieldChangeKeyValue("partners", event, true);
                          }}
                          onRemove={(event) => {
                            handleFieldChangeKeyValue("partners", event, true);
                          }}
                        />

                        {errors.partners && (
                          <span className="error-msg">
                            Channel Partner is required
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="channel-details">
              <h3>Channel Details</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Channel ID <span>*</span>
                  </label>
                  <input
                    name="channelId"
                    placeholder="Enter Channel Id"
                    required
                    {...register("channelId", {
                      required: "Channel ID is required",
                    })}
                    type="text"
                    value={channelId}
                    onChange={handleChennelIdChange}
                    onBlur={handleChennelIdChange}
                    disabled={isEdit ? "disabled" : ""}
                    className={isEdit ? "notAllowed" : ""}
                  />
                  {errors.channelId && (
                    <span className="error-msg">Channel ID is required</span>
                  )}
                </div>

                <div className="form-group">
                  <label>
                    Channel Type <span>*</span>
                  </label>
                  <select
                    {...register("channelType", {
                      required: "Channel Type is required",
                    })}
                    name="type"
                    onChange={(event) => {
                      handleFieldChangeKeyValue(
                        event.target.name,
                        event.target.value,
                        event.target.required
                      );
                    }}
                    onBlur={(event) => {
                      handleFieldChangeKeyValue(
                        event.target.name,
                        event.target.value,
                        event.target.required
                      );
                    }}
                    value={formData.type}
                    required
                  >
                    {channelTypeList.map((item, index) => {
                      return (
                        <option key={index} value={item.type}>
                          {item.type}
                        </option>
                      );
                    })}
                    {errors.channelType && (
                      <span className="error-msg">
                        Channel Type is required
                      </span>
                    )}
                  </select>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Channel Assembly <span>*</span>
                  </label>
                  <select
                    name="channelAssembly"
                    {...register("channelAssembly", {
                      required: "Channel Assembly is required",
                    })}
                    disabled={assemblyEdit}
                    value={formData.channelAssembly}
                    className={assemblyEdit ? "notAllowed" : ""}
                    onChange={(event) => {
                      handleFieldChangeKeyValue(
                        event.target.name,
                        event.target.value,
                        event.target.required
                      );
                      setfilterRequirement(event.target.value);
                    }}
                    required
                  >
                    <option value="RUNN_MEDIA">Runn Playout</option>
                    <option value="AWS">AWS MediaTailor</option>
                    <option value="EXTERNAL">External</option>
                  </select>
                  {errors.channelAssembly && (
                    <span className="error-msg">
                      Channel Assembly is required
                    </span>
                  )}
                </div>

                <div className="toggle-section">
                  <div
                    className="form-grid"
                    style={{ gridTemplateColumns: "1fr 1fr 1fr" }}
                  >
                    {[
                      { name: "isStartOverEnabled", label: "Start Over" },
                      { name: "isWatchListEnabled", label: "Watch List" },
                      { name: "isKidsSafe", label: "Kids Safe" },
                    ].map((toggle) => {
                      let val = formData[toggle.name];

                      return (
                        <div
                          className="form-group"
                          key={toggle.name}
                          style={{ justifyContent: "center" }}
                        >
                          <Controller
                            name={toggle.name}
                            control={control}
                            render={({ field }) => (
                              <ToggleButtonChannel
                                label={toggle.label}
                                name={toggle.name}
                                value={val}
                                onChange={handleFieldChangeKeyValue}
                                required
                              />
                            )}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {formData?.channelAssembly === "EXTERNAL" && (
                <>
                  <div className="form-grid">
                    <div className="form-group">
                      <label>
                        EPG Handler <span>*</span>
                      </label>
                      <select
                        name="epgHandler"
                        {...register("epgHandler", {
                          required: " EPG Handler is required ",
                        })}
                        value={formData?.epgHandler}
                        onChange={(event) => {
                          handleFieldChangeKeyValue(
                            event.target.name,
                            event.target.value,
                            event.target.required
                          );
                        }}
                        onBlur={(event) => {
                          handleFieldChangeKeyValue(
                            event.target.name,
                            event.target.value,
                            event.target.required
                          );
                        }}
                        required
                      >
                        <option value="">Select EPG Handler</option>

                        {epgHandlerData?.length > 0 ? (
                          epgHandlerData.map((data) => (
                            <option value={data} key={data}>
                              {data}
                            </option>
                          ))
                        ) : (
                          <option disabled>Loading EPG Handler...</option>
                        )}
                      </select>
                      {errors.epgHandler && (
                        <span className="error-msg">
                          EPG Handler is required
                        </span>
                      )}
                    </div>

                    <div className="form-group">
                      <label>
                        EPG Type <span>*</span>
                      </label>
                      <select
                        name="epgType"
                        {...register("epgType", {
                          required: "EPG Type is required",
                        })}
                        value={formData.epgType}
                        onChange={(event) => {
                          handleFieldChangeKeyValue(
                            event.target.name,
                            event.target.value,
                            event.target.required
                          );
                        }}
                        onBlur={(event) => {
                          handleFieldChangeKeyValue(
                            event.target.name,
                            event.target.value,
                            event.target.required
                          );
                        }}
                        required
                      >
                        <option value="">Select EPG Type</option>

                        <option value="APIDriven">API Driven</option>
                        <option value="XLSInput">XLS Input</option>
                      </select>
                      {errors.epgType && (
                        <span className="error-msg">EPG Type is required</span>
                      )}
                    </div>

                    {formData.epgType === "APIDriven" && (
                      <>
                        <div className="form-group">
                          <label>
                            API URL <span>*</span>
                          </label>
                          <input
                            name="epgTypeApiUrl"
                            type="text"
                            {...register("epgTypeApiUrl", {
                              required: "API URL is required",
                            })}
                            placeholder="Enter API URL"
                            required
                            value={formData.epgTypeApiUrl}
                            onChange={(event) => handleapiUrlChange(event)}
                            onBlur={(event) => handleapiUrlChange(event)}
                          />
                          {errors.epgTypeApiUrl && (
                            <span className="error-msg">
                              API URL is required
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Ratings <span>*</span>
                  </label>

                  <select
                    name="ratingId"
                    {...register("ratingId", {
                      required: "Rating is required",
                    })}
                    value={formData.ratingId}
                    onChange={(event) => {
                      handleFieldChangeKeyValue(
                        "ratingId",
                        Number(event.target.value),
                        true
                      );
                    }}
                    required
                  >
                    <option value="" disabled>
                      Select a rating
                    </option>

                    {Ratings?.length > 0 ? (
                      Ratings.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>Loading ratings...</option>
                    )}
                  </select>
                  {errors.ratingId && (
                    <span className="error-msg">Rating is required</span>
                  )}
                </div>
                <div className="toggle-section">
                  <div
                    className="form-grid"
                    style={{ gridTemplateColumns: "1fr 1fr 1fr" }}
                  >
                    <div
                      className="form-group"
                      key="isForceLogin"
                      style={{ justifyContent: "center" }}
                    >
                      <Controller
                        name="isForceLogin"
                        control={control}
                        render={({ field }) => (
                          <ToggleButtonChannel
                            label="Force Login"
                            name="isForceLogin"
                            value={formData.isForceLogin}
                            onChange={handleFieldChangeKeyValue}
                            required
                          />
                        )}
                      />
                    </div>
                    {formData.isForceLogin && (
                      <div className="form-group" key="forceLoginWatchDuration">
                        <label>
                          Duration
                          <span>*</span> <span className="format">(hh:mm:ss)</span>
                        </label>
                        <Controller
                          name="forceLoginWatchDuration"
                          control={control}
                          render={({ field }) => (
                            <>
                              <TimePicker
                                className="forceLoginduration duration "
                                value={formData.forceLoginWatchDuration}
                                // disabled={false}
                                hourPlaceholder="HH"
                                minutePlaceholder="MM"
                                secondPlaceholder="SS"
                                maxDetail="second"
                                minTime="00:00:00"
                                format="HH:mm:ss"
                                onChange={(e) => {
                                  handleDurationChange(e);
                                }}
                                disableClock
                              />
                              {errors.forceLoginWatchDuration && (
                                <span className="error-msg">
                                  Duration is required
                                </span>
                              )}
                            </>
                          )}
                        />
                      </div>
                    )}
                    <div
                      className="form-group"
                      key="applyLogo"
                      style={{ justifyContent: "center" }}
                    >
                      <Controller
                        name="applyLogo"
                        control={control}
                        render={({ field }) => (
                          <ToggleButtonChannel
                            label="Enable Logo"
                            name="applyLogo"
                            value={formData.applyLogo}
                            onChange={handleFieldChangeKeyValue}
                            required
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Go-Live Date <span>*</span>
                  </label>
                  <Controller
                    name="goLiveDate"
                    control={control}
                    rules={{ required: "Required" }}
                    render={({ field }) => (
                      <CustomDatePickerField
                        name="goLiveDate"
                        value={formData.goLiveDate}
                        onChange={handleFieldChangeKeyValue}
                      />
                    )}
                  />
                </div>

                <div className="form-group">
                  <label>Channel Setup Date</label>
                  <Controller
                    name="channelSetupDate"
                    control={control}
                    render={({ field }) => (
                      <CustomDatePickerField
                        name="channelSetupDate"
                        value={formData.channelSetupDate}
                        disabled={true}
                        onChange={(event) =>
                          handleFieldChangeKeyValue(
                            "channelSetupDate",
                            event,
                            false
                          )
                        }
                      />
                    )}
                  />
                </div>
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Source Timezone <span>*</span>
                  </label>

                  <Controller
                    name="timezones"
                    control={control}
                    rules={{ required: "Source Timezone is required" }}
                    render={({ field }) => (
                      <>
                        <MultiSelectField
                          options={timezoneList}
                          className="MultiSelectContainer"
                          selectedValues={formData.timezones || []}
                          placeholder="Select Source Timezone"
                          displayValue="timezone"
                          required
                          onSelect={(event) => {
                            handleFieldChangeKeyValue("timezones", event, true);
                          }}
                          onRemove={(event) => {
                            handleFieldChangeKeyValue("timezones", event, true);
                          }}
                        />

                        {errors.timezones && (
                          <span className="error-msg">
                            Source Timezone is required
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
                {/* <div className="form-group">
                  <label>
                    Schedule Type <span>*</span>
                  </label>
                  <select
                    name="scheduleType"
                    {...register("scheduleType", {
                      required: "Schedule Type is required",
                    })}
                    value={formData.scheduleType}
                    onChange={(event) => {
                      handleFieldChangeKeyValue(
                        event.target.name,
                        event.target.value,
                        event.target.required
                      );
                    }}
                    onBlur={(event) => {
                      handleFieldChangeKeyValue(
                        event.target.name,
                        event.target.value,
                        event.target.required
                      );
                    }}
                    required
                  >
                    <option value="Standard">Standard</option>
                    <option value="Align TimeZone">Align TimeZone</option>
                    <option value="TimeZone Specific">TimeZone Specific</option>
                  </select>
                  {errors.scheduleType && (
                    <span className="error-msg">Schedule Type is required</span>
                  )}
                </div> */}
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Territory <span>*</span>
                  </label>
                  <Controller
                    name="territoryDetails"
                    control={control}
                    rules={{ required: "Territory is required" }}
                    render={({ field }) => (
                      <>
                        <MultiSelectField
                          options={territoryOption}
                          className="MultiSelectContainer"
                          selectedValues={formData.territoryDetails || []}
                          placeholder="Select Territory"
                          displayValue="territoryName"
                          required
                          onSelect={(event) => {
                            handleFieldChangeKeyValue(
                              "territoryDetails",
                              event,
                              true
                            );
                          }}
                          onRemove={(event) => {
                            handleFieldChangeKeyValue(
                              "territoryDetails",
                              event,
                              true
                            );
                          }}
                        />

                        {errors.territoryDetails && (
                          <span className="error-msg">
                            Territory is required
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Language <span>*</span>{" "}
                  </label>
                  <select
                    name="regionalLanguage"
                    {...register("regionalLanguage", {
                      required: "Language is required",
                    })}
                    value={formData.regionalLanguage}
                    onChange={(event) => {
                      handleFieldChangeKeyValue(
                        event.target.name,
                        event.target.value,
                        event.target.required
                      );
                    }}
                    required
                  >
                    {languageList?.length > 0 ? (
                      languageList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>Loading languages...</option>
                    )}
                  </select>
                  {errors.regionalLanguage && (
                    <span className="error-msg">Language is required</span>
                  )}
                </div>
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Channel Category <span>*</span>
                  </label>
                  <Controller
                    name="categories"
                    control={control}
                    render={({ field }) => (
                      <>
                        <MultiSelectField
                          options={categoryOption}
                          className="MultiSelectContainer"
                          selectedValues={formData.categories || []}
                          placeholder="Select Channel Category"
                          displayValue="name"
                          required
                          onSelect={(event) => {
                            handleFieldChangeKeyValue(
                              "categories",
                              event,
                              true
                            );
                          }}
                          onRemove={(event) => {
                            handleFieldChangeKeyValue(
                              "categories",
                              event,
                              true
                            );
                          }}
                        />
                        {errors.categories && (
                          <span className="error-msg">
                            Channel Category is required
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
                <div className="form-group">
                  <label>Channel Theme</label>
                  <Controller
                    name="theme"
                    control={control}
                    render={({ field }) => (
                      <MultiSelectField
                        className="MultiSelectContainer"
                        options={themeList}
                        displayValue="name"
                        selectedValues={formData.theme}
                        placeholder="Select Theme"
                        onSelect={(event) => {
                          handleFieldChangeKeyValue("theme", event, false);
                        }}
                        onRemove={(event) => {
                          handleFieldChangeKeyValue("theme", event, false);
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="form-grid">
                {formData?.channelAssembly !== "EXTERNAL" && (
                  <div className="form-group">
                    <label>
                      Default Filler <span>*</span>
                    </label>
                    <select
                      name="fillerSourcePath"
                      {...register("fillerSourcePath", {
                        required: "Default Filler is required",
                      })}
                      value={
                        formData.fillerSourcePath === ""
                          ? PartnerfillerList[0]?.id
                          : formData.fillerSourcePath
                      }
                      onChange={(event) => {
                        handleFieldChangeKeyValue(
                          event.target.name,
                          event.target.value,
                          false
                        );
                      }}
                    >
                      {PartnerfillerList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {truncateValue(item.sourcePath)}
                          </option>
                        );
                      })}
                      {fillerList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {truncateValue(item.sourcePath)}
                          </option>
                        );
                      })}{" "}
                    </select>
                    {errors.fillerSourcePath && (
                      <span className="error-msg">
                        {errors.fillerSourcePath.message}
                      </span>
                    )}
                  </div>
                )}
                <div className="form-group">
                  <label>Channel Tags</label>
                  <Controller
                    name="channelTags"
                    control={control}
                    render={({ field }) => (
                      <div className="tagInput-field">
                        <TagsInput
                          value={
                            formData.channelTags[0] === ""
                              ? []
                              : formData.channelTags
                          }
                          onChange={(event) => {
                            handleFieldChangeKeyValue("channelTags", event);
                          }}
                          name="channelTags"
                          placeHolder="Enter Channel Tags"
                          classNames={{
                            tag: "tag-chip",
                            input: "tag-input",
                          }}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>Playout Base URL {isEdit ? <span>*</span> : ""}</label>
                  <input
                    {...register("playoutBaseUrl")}
                    name="playoutBaseUrl"
                    type="text"
                    placeholder="Enter Playout Base URL "
                    // required={isEdit ? true : false}
                    value={playoutBaseUrl}
                    onChange={handleplayoutBaseUrlChange}
                    onBlur={handleplayoutBaseUrlChange}
                  />
                </div>

                <div className="form-group">
                  <label>Playout URL {isEdit ? <span>*</span> : ""}</label>
                  <input
                    {...register("playbackUrl")}
                    name="playbackUrl"
                    type="text"
                    // disabled={externalUrlBool ? false : !isEdit}
                    // className={!isEdit ? "notAllowed" : ""}
                    placeholder="Enter Playout URL"
                    value={formData.playbackUrl}
                    // required={isEdit ? true : false}
                    onChange={(event) => {
                      handleFieldChangeKeyValue(
                        event.target.name,
                        event.target.value
                      );
                    }}
                  />
                </div>
              </div>
              <div className="form-group">
                <Controller
                  name="description"
                  control={control}
                  render={({ field }) => (
                    <div className="form-field">
                      <label>Channel Description</label>

                      <textarea
                        placeholder="Enter channel Description"
                        className="label-bg-details customTextArea"
                        name="description"
                        ref={textareaRef}
                        style={{
                          height: description.length !== 0 ? "auto" : "40px",
                        }}
                        onChange={handleDescriptionChange}
                        wrap="soft" // allows word wrapping
                        value={description}
                      />

                      <div
                        className="field-length"
                        style={{ textAlign: "right", width: "100%" }}
                      >
                        {description.length}/2500
                      </div>
                    </div>
                  )}
                />
              </div>
              <div className="form-group">
                <Controller
                  name="customAttributes"
                  control={control}
                  render={({ field }) => (
                    <JsonTextArea
                      placeholder="Enter custom attributes"
                      label="Custom Attributes"
                      className="customTextArea"
                      name={"customAttributes"}
                      customAttributes={
                        customAttributes != null
                          ? customAttributes
                          : JSON.stringify(defaultattributes, null, 2)
                      }
                      handlecustomAttributesChange={
                        handlecustomAttributesChange
                      }
                      handleFormatJson={handleFormatJson}
                      expandModal={expandModal}
                      icon={expandIcon}
                    />
                  )}
                />
              </div>
            </div>
            <div>
              <div className="form-group">
                <h3 style={{ marginBottom: "10px" }}>
                  Channel image<span style={{ color: "#ba1b1b" }}>*</span>{" "}
                  <span class="desc">
                    {" "}
                    (Upload all posters for at least one device)
                  </span>
                </h3>
                <FileUploaderContainer
                  files={formData.channelImages}
                  onChange={handleFileUploader}
                  isNewChannel={!externalUrlBool}
                />
                {errors.channelImages && (
                  <span className="error-msg">
                    Channel images are required for at least one device
                  </span>
                )}
              </div>
            </div>
          </form>
        </div>
        {permission === "edit" ? (
          <div className="buttonsContainer">
            <button
              type="button"
              onClick={backToChannel}
              className="btn cancelBtn"
            >
              Cancel
            </button>
            <div className="button-row">
              {/* disabled={validateForm()} */}
              <button
                type="button"
                className="btn resetBtn"
                onClick={resetForm}
              >
                Reset
              </button>
              <button
                type="button"
                onClick={() => {
                  saveChannel();
                }}
                className="btn createBtn"
              >
                {/* {isEdit ? 'Update' : 'Create'} */}
                {externalUrlBool ? "Update" : "Create"}
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        <CDNPopUp
          show={showPopup}
          handleClose={closePopup}
          formData={formData}
          setFormData={setFormData}
          setErrors={setErrors}
          errors={errors}
        />
        <ToastContainer />
        <CustomAttributeModal
          data={
            customAttributes != null
              ? customAttributes
              : JSON.stringify(defaultattributes, null, 2)
          }
          handlecustomAttributesChange={handlecustomAttributesChange}
          handleFormatJson={handleFormatJson}
          expandModal={expandModal}
        />
      </div>
    </div>
  ) : (
    ""
  );
}

export default ChannelCreation;
